import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import TranslationService from "../../Services/Translation/TranslationService";
/** Redux Import */
import { useDispatch } from "react-redux";
/** Components Import */
import Sections from "./Sections";
import Loading from "../../Components/Loading";
import AutoTranslate from "../../Components/AutoTranslate";

function Main() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [mainContent, setMainContent] = useState(null);
  const [entertainment, setEntertainment] = useState([]);
  const [issue, setIssue] = useState([]);
  const [news, setNews] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [showNoticeModal, setShowNoticeModal] = useState(false);
  const [noticeData, setNoticeData] = useState(null);
  const language = useSelector((state) => state.localStorage.language);

  useEffect(() => {
    console.log("location: ", location);
    Init();
  }, []);

  useEffect(() => {
    if (mainContent) setSelectedContent(mainContent);
  }, [mainContent]);

  const Init = async () => {
    setLoading(true);
    try {
      await Search();
      if (location.state?.notice) {
        const notice = location.state.notice;
        const totalCount = (notice.approved || 0) + (notice.rejected || 0);

        if (totalCount > 0 && !Commons.Storages("get", "popup").loginEduPopup) {
          setNoticeData(notice);
          setShowNoticeModal(true);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  // 메인 컨텐츠 조회 및 분리
  const Search = async () => {
    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.MainContentList);
      const data = result.data;
      // console.log("콘텐츠 API 응답:", data);
      let items = Array.isArray(data) ? data : Array.isArray(data.items) ? data.items : [];
      const main = items.find((item) => item.code === "MAIN");
      setMainContent(main ? main.content : null);
      setEntertainment(items.filter((item) => ["ENT01", "ENT02", "ENT03", "ENT04"].includes(item.code)));
      setIssue(items.filter((item) => ["ISSUE01", "ISSUE02", "ISSUE03", "ISSUE04"].includes(item.code)));
      setNews(items.filter((item) => ["NEWS01", "NEWS02", "NEWS03", "NEWS04"].includes(item.code)));
    } catch (e) {
      console.log("콘텐츠 조회 오류:", e);
    }
  };

  // 더보기 클릭 조회(기존 유지)
  const Search1 = async (_param) => {
    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.Search, { q: _param });
      const data = result.data;
      if (!data) throw new Error(data);
      if (data.type === "Error") throw new Error(data.message);
      navigate("/search-result", { state: { data: data, searchText: _param } });
    } catch (e) {
      console.log("Search1 Error: ", e);
    }
  };

  const contentList = [mainContent, news[0], issue[0], entertainment[0]].filter(Boolean);

  return (
    <div className='wrapper' style={{ padding: 0 }}>
      {/* 교육 알림 모달 */}
      {showNoticeModal && noticeData && (
        <div className='modern-notice-modal-overlay'>
          <div className='modern-notice-modal'>
            <div className='modern-notice-modal-header'>
              <div className='modern-notice-icon'>
                <span style={{ fontSize: "2.5rem" }}>📚</span>
              </div>
              <h3 className='modern-notice-title'>
                <AutoTranslate targetLanguage={language.lang}>교육 알림</AutoTranslate>
              </h3>
            </div>
            <div className='modern-notice-modal-body'>
              <div className='modern-notice-content'>
                <p className='modern-notice-message'>
                  <AutoTranslate targetLanguage={language.lang}>
                    {noticeData.approved > 0 && noticeData.rejected > 0
                      ? `현재 승인된 교육 ${noticeData.approved}개와 반려된 교육 ${noticeData.rejected}개가 있습니다.`
                      : noticeData.approved > 0
                      ? `현재 승인된 교육 ${noticeData.approved}개가 있습니다.`
                      : `현재 반려된 교육 ${noticeData.rejected}개가 있습니다.`}
                  </AutoTranslate>
                </p>
                <div className='modern-notice-stats'>
                  <div className='modern-notice-stat approved'>
                    <span className='modern-notice-stat-icon'>✅</span>
                    <span className='modern-notice-stat-label'>
                      <AutoTranslate targetLanguage={language.lang}>승인</AutoTranslate>
                    </span>
                    <span className='modern-notice-stat-count'>{noticeData.approved}</span>
                  </div>
                  <div className='modern-notice-stat rejected'>
                    <span className='modern-notice-stat-icon'>❌</span>
                    <span className='modern-notice-stat-label'>
                      <AutoTranslate targetLanguage={language.lang}>반려</AutoTranslate>
                    </span>
                    <span className='modern-notice-stat-count'>{noticeData.rejected}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='modern-notice-modal-footer'>
              <button
                className='modern-notice-btn modern-notice-btn-secondary'
                onClick={() => {
                  Commons.Storages("set", "popup", {
                    ...Commons.Storages("get", "popup"),
                    loginEduPopup: true,
                  });
                  setShowNoticeModal(false);
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>닫기</AutoTranslate>
              </button>
              <button
                className='modern-notice-btn modern-notice-btn-primary'
                onClick={() => {
                  Commons.Storages("set", "popup", {
                    ...Commons.Storages("get", "popup"),
                    loginEduPopup: true,
                  });
                  setShowNoticeModal(false);
                  navigate("/selected-company");
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>교육 들으러 가기</AutoTranslate>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 모바일: 메인 featured row가 숨겨질 때, 메인 콘텐츠만 자동 재생 */}
      <div className='main-mobile-featured-row'>
        {typeof mainContent === "object" &&
          mainContent &&
          (typeof mainContent.content === "string" ? (
            <video
              src={mainContent.content}
              autoPlay
              muted
              loop
              playsInline
              className='main-featured-img persist-video'
              controlsList='nodownload noplaybackrate nofullscreen noremoteplayback'
              disablePictureInPicture
              disableRemotePlayback
              style={{ width: "100%", borderRadius: "1rem", marginBottom: "1rem" }}
            />
          ) : mainContent.content?.content ? (
            <video
              src={mainContent.content.content}
              autoPlay
              muted
              loop
              playsInline
              className='main-featured-img persist-video'
              controlsList='nodownload noplaybackrate nofullscreen noremoteplayback'
              disablePictureInPicture
              disableRemotePlayback
              style={{ width: "100%", borderRadius: "1rem", marginBottom: "1rem" }}
            />
          ) : mainContent.thumbnail ? (
            <img src={mainContent.thumbnail} alt={mainContent.title} className='main-featured-img' style={{ width: "100%", borderRadius: "1rem", marginBottom: "1rem" }} />
          ) : mainContent.content?.thumbnail ? (
            <img
              src={mainContent.content.thumbnail}
              alt={mainContent.content.title || mainContent.name}
              className='main-featured-img'
              style={{ width: "100%", borderRadius: "1rem", marginBottom: "1rem" }}
            />
          ) : null)}
      </div>
      {/* 1:3:1 비율 상단 featured 영역 */}
      <div className='main-featured-row unified-bg'>
        {/* 왼쪽: 제목/설명 */}
        <div className='main-featured-left unified-bg'>
          <div
            className='main-featured-info-overlap'
            onClick={() => {
              if (selectedContent) {
                navigate("/watch", { state: { data: selectedContent } });
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <div className='main-featured-badge'>
              <AutoTranslate targetLanguage={language.lang}>{selectedContent?.category || selectedContent?.content?.category || "추천"}</AutoTranslate>
            </div>
            <h2>
              <AutoTranslate targetLanguage={language.lang}>{selectedContent?.title || selectedContent?.content?.title || "대표 콘텐츠"}</AutoTranslate>
            </h2>
            <div className='main-featured-desc'>
              <AutoTranslate targetLanguage={language.lang}>{selectedContent?.desc || selectedContent?.content?.desc || ""}</AutoTranslate>
            </div>
          </div>
        </div>
        {/* 가운데: 영상/이미지 */}
        <div className='main-featured-center unified-bg'>
          {selectedContent &&
            (typeof selectedContent.content === "string" ? (
              <video
                src={selectedContent.content}
                autoPlay
                muted
                loop
                playsInline
                className='main-featured-img persist-video'
                controlsList='nodownload noplaybackrate nofullscreen noremoteplayback'
                disablePictureInPicture
                disableRemotePlayback
              />
            ) : selectedContent.content?.content ? (
              <video
                src={selectedContent.content.content}
                autoPlay
                muted
                loop
                playsInline
                className='main-featured-img persist-video'
                controlsList='nodownload noplaybackrate nofullscreen noremoteplayback'
                disablePictureInPicture
                disableRemotePlayback
              />
            ) : selectedContent.thumbnail ? (
              <img src={selectedContent.thumbnail} alt={selectedContent.title} className='main-featured-img' />
            ) : selectedContent.content?.thumbnail ? (
              <img src={selectedContent.content.thumbnail} alt={selectedContent.content.title || selectedContent.name} className='main-featured-img' />
            ) : (
              <div className='main-featured-img main-featured-img-placeholder' />
            ))}
        </div>
        {/* 오른쪽: 4가지 선택지 */}
        <div className='main-featured-right unified-bg'>
          {contentList.map((item, idx) => (
            <div
              className={`main-featured-sub${item === selectedContent ? " selected" : ""}`}
              key={idx}
              onClick={() => setSelectedContent(item)}
              style={{ cursor: "pointer" }}
              aria-selected={item === selectedContent}
            >
              {item?.thumbnail ? (
                <img src={item.thumbnail} alt={item.title} className='main-featured-sub-img' />
              ) : item?.content?.thumbnail ? (
                <img src={item.content.thumbnail} alt={item.content.title || item.name} className='main-featured-sub-img' />
              ) : (
                <div className='main-featured-sub-img main-featured-img-placeholder' />
              )}
              <div className='main-featured-sub-info'>
                <div className='main-featured-sub-title'>
                  <AutoTranslate targetLanguage={language.lang}>{item?.title || item?.content?.title || item?.name}</AutoTranslate>
                </div>
                <div className='main-featured-sub-meta'>
                  <AutoTranslate targetLanguage={language.lang}>{item?.category || item?.content?.category || ""}</AutoTranslate>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='flex-column'>
        <Sections
          title='안방 뉴스'
          items={news.slice(0, 4).map((item) => ({
            image: item.content && item.content.thumbnail ? item.content.thumbnail : "",
            title: item.content && item.content.title ? item.content.title : item.name,
            date: item.content && item.content.createdAt ? item.content.createdAt.split("T")[0] : "",
            raw: item,
          }))}
          onMoreClick={() => Search1("뉴스")}
          onItemClick={(item) => navigate("/watch", { state: { data: item.raw, searchText: "뉴스" } })}
        />
        <div className='main-section-block-divider' />
        <Sections
          title='안방 시사'
          items={issue.slice(0, 4).map((item) => ({
            image: item.content && item.content.thumbnail ? item.content.thumbnail : "",
            title: item.content && item.content.title ? item.content.title : item.name,
            date: item.content && item.content.createdAt ? item.content.createdAt.split("T")[0] : "",
            raw: item,
          }))}
          onMoreClick={() => Search1("안전 시사")}
          onItemClick={(item) => navigate("/watch", { state: { data: item.raw, searchText: "시사" } })}
        />
        <div className='main-section-block-divider' />
        <Sections
          title='안방 예능'
          items={entertainment.slice(0, 4).map((item) => ({
            image: item.content && item.content.thumbnail ? item.content.thumbnail : "",
            title: item.content && item.content.title ? item.content.title : item.name,
            date: item.content && item.content.createdAt ? item.content.createdAt.split("T")[0] : "",
            raw: item,
          }))}
          onMoreClick={() => Search1("안전 예능")}
          onItemClick={(item) => navigate("/watch", { state: { data: item.raw, searchText: "예능" } })}
        />
      </div>
      <footer className='footer flex-column-center-center p-4'>
        <span>© SAFEWAY All rights reserved.</span>
        <span style={{ fontSize: "0.8rem", color: "#9aa2b1" }}>{Commons.Storages("get", "version")?.version}</span>
      </footer>
      {loading && <Loading />}
    </div>
  );
}

export default Main;
